import React from 'react';
import { Workplace } from '../../../../graphql/graphql';

interface Props {
	item: Workplace;
	onSelect: (workplaceId: string) => void;
}

const WorkplaceSelectionItem: React.FC<Props> = ({ item, onSelect }) => {


	return (
		<a
			onClick={() => onSelect(item.id)}
			className='meddi-btn button-list__btn theme-gray mt-3'
			style={{ cursor: 'pointer' }}>
			<div className='button-list__btn__content'>{item.name}</div>
			<div className='button-list__btn__arrow'>
				<img
					src='/dist/patientV3/icons/arrow-right-purple-small.svg'
					alt=''
				/>
			</div>
		</a>
	);
};

export default WorkplaceSelectionItem;